import { render, staticRenderFns } from "./AppHero.vue?vue&type=template&id=10e2d3ee&scoped=true&"
import script from "./AppHero.vue?vue&type=script&lang=ts&"
export * from "./AppHero.vue?vue&type=script&lang=ts&"
import style0 from "./AppHero.vue?vue&type=style&index=0&id=10e2d3ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e2d3ee",
  null
  
)

export default component.exports